import { takeEvery } from "@redux-saga/core/effects";
import { PaymentActionTypes } from "../types";
import { updatePaymentOption } from "./setPaymentOptionSaga";
import { authPayPalUserSaga } from "./authPayPaylSaga";
import { disconnectPaymentSaga } from "./disconnectPaymentSaga";
import { activatePaymentCashSaga } from "./activatePaymentMethodCashSaga";
import { createPromoCodeSaga } from "./createPromoCodeSaga";
import { updatePromoCodeSaga } from "./updatePromoCodeSaga";
import { deletePromoCodeSaga } from "./deletePromoCodeSaga";
import { duplicatePromoCodeSaga } from "./duplicatePromoCodeSaga";
import { authStripeUserSaga } from "./authStripeUserSaga";
import { confirmStripeAuthSaga } from "./confirmStripeAuthSaga";
import { authSquareUserSaga } from "./authSquaeUserSaga";
import { getSquareSubPlansSaga } from "./getSquareSubscriptionsSaga";

export default function* paymentSaga() {
    yield takeEvery(PaymentActionTypes.UPDATE_PAYMENT_REQUEST, updatePaymentOption);
    yield takeEvery(PaymentActionTypes.AUTH_PAYPAL_USER_REQUEST, authPayPalUserSaga);
    yield takeEvery(PaymentActionTypes.AUTH_STRIPE_USER_REQUEST, authStripeUserSaga);
    yield takeEvery(PaymentActionTypes.AUTH_SQUARE_USER_REQUEST, authSquareUserSaga);
    yield takeEvery(PaymentActionTypes.CONFIRM_STRIPE_AUTH_REQUEST, confirmStripeAuthSaga);
    yield takeEvery(PaymentActionTypes.DISCONNECT_PAYMENT_METHOD, disconnectPaymentSaga);
    yield takeEvery(PaymentActionTypes.ACTIVATE_PAYMENT_METHOD_CASH, activatePaymentCashSaga);
    yield takeEvery(PaymentActionTypes.CREATE_PROMOCODE, createPromoCodeSaga);
    yield takeEvery(PaymentActionTypes.UPDATE_PROMOCODE, updatePromoCodeSaga);
    yield takeEvery(PaymentActionTypes.DELETE_PROMOCODE, deletePromoCodeSaga);
    yield takeEvery(PaymentActionTypes.DUPLICATE_PROMOCODE, duplicatePromoCodeSaga);
    yield takeEvery(PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_REQUEST, getSquareSubPlansSaga);
}
